module.exports = __webpack_public_path__ + "static/media/cachorro.d0de94e0.png";